import {Component, OnInit, TemplateRef} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap/modal';

@Component({
  selector: 'lib-empfaengerdetails',
  templateUrl: './empfaengerdetails.component.html',
  styleUrls: ['./empfaengerdetails.component.css']
})
export class EmpfaengerdetailsComponent implements ICellRendererAngularComp, OnInit {

  modalRef: BsModalRef;
  faInfoCircle = faInfoCircle;
  public params: ICellRendererParams;

  constructor(private modalService: BsModalService) { }

  ngOnInit(): void {
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  displayInfos(template: TemplateRef<any>): void {
    const config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      ignoreBackdropClick: true,
    };
    this.modalRef = this.modalService.show(template, config);
  }

  showEmpfaengerName(param: any) {
    const name1 = param.data.empfaengerName1 !== null ? param.data.empfaengerName1 : '';
    const name2 = param.data.empfaengerName2 !== null ? param.data.empfaengerName2 : '';
    const name3 = param.data.empfaengerName3 !== null ? param.data.empfaengerName3 : '';
    return name1 + ' ' + name2 + ' ' + name3;
  }

}
